import { supabase } from '../../supabaseClient';

export const saveSupplier = async (id = undefined, item, userId = undefined) => {
  if (id) {
    return await supabase
      .from('Supplier')
      .update({ ...item, updated_at: new Date(), updated_by: userId ?? null })
      .match({ id });
  }
  return await supabase
    .from('Supplier')
    .insert([{ ...item, created_by: userId ?? null }]);
};

export const loadSuppliers = async (companyId) => {
  let { data, error } = await supabase
    .from('Supplier')
    .select('*')
    .eq('company_id', companyId)
    .is('deleted_at', null)
    .order('name', { ascending: true });
  if (!error) {
    return data;
  }
  return [];
};

export const loadSupplierById = async (id) => {
  let { data, error } = await supabase
    .from('Supplier')
    .select('*')
    .eq('id', id)
    .is('deleted_at', null);
  if (!error && data?.length > 0) {
    return data[0];
  }
  return null;
};

export const deleteSupplier = async (id, userId) => {
  return await supabase
    .from('Supplier')
    .update({ deleted_at: new Date(), deleted_by: userId })
    .match({ id });
};

// RN04/CA05: bloqueia cadastro duplicado por Nome (case-insensitive) e, quando
// o CPF/CNPJ é informado, também por CPF/CNPJ. Ignora o próprio registro em
// edição (ignoreId) e registros soft-deletados. Retorna true se já existe.
export const findDuplicateSupplier = async (companyId, name, cpfCnpj, ignoreId) => {
  let query = supabase
    .from('Supplier')
    .select('id, name, cpf_cnpj')
    .eq('company_id', companyId)
    .is('deleted_at', null)
    .ilike('name', (name || '').trim());

  if (cpfCnpj) {
    query = query.eq('cpf_cnpj', cpfCnpj);
  }
  if (ignoreId) {
    query = query.neq('id', ignoreId);
  }

  const { data, error } = await query;
  if (error || !data) {
    return false;
  }
  return data.length > 0;
};
